module.exports = __webpack_public_path__ + "img/star.112b21d4.svg";